var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller("AddToCartController",
    ["$rootScope", "$scope", "$window", '$document', "cartService",
        function ($rootScope, $scope, $window, $document, cartService) {

            function getCart(updateCart) {
                updateCart = angular.isDefined(updateCart) ? updateCart : false;
                if (updateCart) {
                    addToCart($scope.currentPrdId, true);
                }
            }

            $scope.addToCart = function (productId, isCheckout, selectedVarId, quantity, isBuyAllSizes) {
                quantity = angular.isDefined(quantity) ? quantity : 1;
                isBuyAllSizes = angular.isDefined(isBuyAllSizes) ? isBuyAllSizes : false;
                selectedVarId = angular.isDefined(selectedVarId) ? selectedVarId : "1";
                var itemIdToAdd = "";
                if (selectedVarId != "1") {
                    itemIdToAdd = productId + "_var_" + selectedVarId;
                }
                addToCart(productId, isCheckout, itemIdToAdd, quantity, isBuyAllSizes);
            }

            // #region Adding to cart from URL - Event will be emitted from product controller
            $rootScope.$on("AddToCart", function (evt, data) {
                if (data) {
                    if (!$rootScope.customerCartRS) {
                        $scope.currentPrdId = data.productId;
                        getCart(true);
                    }
                    else {
                        addToCart(data.productId, data.isCheckout);
                    }
                }
            });
            //#endregion

            //#region Function to Add Item To Cart
            function addToCart(productId, isCheckout, itemIdToAdd, quantity, isBuyAllSizes) {
                itemIdToAdd = itemIdToAdd == "" ? productId : itemIdToAdd;
                quantity = angular.isDefined(quantity) ? quantity : 1;
                isBuyAllSizes = angular.isDefined(isBuyAllSizes) ? isBuyAllSizes : false;
                isCheckout = (angular.isDefined(isCheckout) && isCheckout.toString().toLowerCase() == 'true') ? isCheckout : false;
                if ($rootScope.customerCartRS && $rootScope.customerCartRS.indexOf(itemIdToAdd) == -1) {
                    var button = $document[0].getElementById("btn_" + productId);
                    if (button) {
                      button.classList.add('loading');
                      var spinner = button.querySelector('.fa-spin');
                      if (spinner) {
                        spinner.classList.remove('loader');
                      }
                    }
                    if (!isBuyAllSizes) {
                        return cartService.addLineItem(itemIdToAdd, quantity).then(function (response) {
                            if (response && response.data && response.data.itemAdded) {
                                this.productAdded = true;
                                if ((response.data.displayFreeDesignAlertMsg && response.data.displayFreeDesignAlertMsg == true) || (response.data.displayFreePdfAlertMsg == true)) {
                                    alert("3 free designs per week with no purchase,\n\n6 free designs per week with $35 purchase, or\n\n9 free designs per week with $75 purchase.\n\n1 free PDF Sewing Pattern per week");
                                }
                                $rootScope.$broadcast('CustomerCartChanged');
                                if ($rootScope.isCartPage) {
                                    location.reload();
                                }
                            }
                            else {
                                alert("Cart has reached Max Limit. Please checkout before adding any more new item's.");
                            }
                            var button = $document[0].getElementById("btn_" + productId);
                            if (button) {
                              button.classList.remove('loading');
                              var spinner = button.querySelector('.fa-spin');
                              if (spinner) {
                                spinner.classList.add('loader');
                              }
                            }
                        });
                    }
                    else {
                        return cartService.addAllVariantsAsLineItems(itemIdToAdd, quantity).then(function (response) {
                            if (response && response.data && response.data.itemAdded) {
                                this.productAdded = true;
                                if ((response.data.displayFreeDesignAlertMsg && response.data.displayFreeDesignAlertMsg == true) || (response.data.displayFreePdfAlertMsg == true)) {
                                    alert("3 free designs per week with no purchase,\n\n6 free designs per week with $35 purchase, or\n\n9 free designs per week with $75 purchase.\n\n1 free PDF Sewing Pattern per week");
                                }
                                $rootScope.$broadcast('CustomerCartChanged');
                                if ($rootScope.isCartPage) {
                                    location.reload();
                                }
                            }
                            else {
                                alert("Cart has reached Max Limit. Please checkout before adding any more new item's.");
                            }
                            var button = $document[0].getElementById("btn_" + productId);
                            if (button) {
                              button.classList.remove('loading');
                              var spinner = button.querySelector('.fa-spin');
                              if (spinner) {
                                spinner.classList.add('loader');
                              }
                            }
                        });
                    }
                }
                else if (isCheckout) {
                    $window.location.href = "/cart";
                }
                else {
                    alert("Item is already in cart");
                }
            }
            // #endregion

            // #region Check Item is already in Cart
            $scope.isItemInCart = function (prodId, variantId) {
                var itemInCart = false;
                var itemId = prodId + (variantId != "1" ? "_var_" + variantId : "");
                if ($rootScope.customerCartRS != null && $rootScope.customerCartRS.length > 0) {
                    if ($rootScope.customerCartRS.indexOf(itemId) != -1) {
                        itemInCart = true;
                    }
                }
                return itemInCart;
            }
            // #endregion
        }
    ]);
